import * as types from '../constants/actionTypes';
import * as constants from '../constants/onDemandConstants';
import LoopbackHttp from '../businessLogic/LoopbackHttp.js';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {startSpinner, endSpinner} from './appActions.js';

function toggleOrders(dispatch, orderType) {
  dispatch({
    type: types.TOGGLE_ORDERS,
    orderType
  });
}

function expandOrders(dispatch, orderType) {
  dispatch({
    type: types.EXPAND_ORDERS,
    orderType
  });
}

function toggleSidebar(dispatch, sidebarType) {
  dispatch({
    type: types.TOGGLE_SIDEBAR,
    sidebarType
  });
}

export function toggleNewOrders() { return dispatch => toggleOrders(dispatch, constants.newOrdersExpand); }

export function toggleInProgressOrders() { return dispatch => toggleOrders(dispatch, constants.inProgressOrdersExpand); }

export function toggleHistoryOrders() { return dispatch => toggleOrders(dispatch, constants.historyOrdersExpand); }

export function expandNewOrders() { return dispatch => expandOrders(dispatch, constants.newOrdersExpand); }

export function expandInProgressOrders() { return dispatch => expandOrders(dispatch, constants.inProgressOrdersExpand); }

export function expandHistoryOrders() { return dispatch => expandOrders(dispatch, constants.historyOrdersExpand); }

export function toggleLeftSidebar() { return dispatch => toggleSidebar(dispatch, constants.leftSidebar); }

export function toggleRightSidebar() { return dispatch => toggleSidebar(dispatch, constants.rightSidebar); }


export function setFilterDate(date) { return dispatch => dispatch({ type: types.SET_FILTER_DATE, date }); }

export function toggleFilterSearch() { return dispatch => dispatch({ type: types.TOGGLE_FILTER_SEARCH }); }

export function setFilterSearch(search) { return dispatch => dispatch({ type: types.SET_FILTER_SEARCH, search }); }

export function setFilterSearchEntered() { return dispatch => dispatch({ type: types.SET_FILTER_SEARCH_ENTERED }); }

export function clearFilter() { return dispatch => dispatch({ type: types.CLEAR_FILTER }); }

function getOrdersForDateImpl(dispatch, companyId, date) {
  dispatch(startSpinner());
  LoopbackHttp.getOrdersForDate(companyId, date)
    .then(orders => {
      dispatch({ type: types.ORDERS_FETCHED, orders });
      dispatch(endSpinner());
    })
    .catch(() => {
      dispatch({ type: types.ORDERS_FETCH_FAILED });
      dispatch(endSpinner());
    });
}

function getAllOrdersForCompanyImpl(dispatch, companyId, date) {
  dispatch(startSpinner());
  LoopbackHttp.getAllOrdersForComapany(companyId, date)
    .then(orders => {
      dispatch({ type: types.ORDERS_COMPANY_FETCHED, orders });
      dispatch(endSpinner());
    })
    .catch(() => {
      dispatch({ type: types.ORDERS_COMPANY_FETCH_FAILED });
      dispatch(endSpinner());
    });
}

function getFilterOrdersForCompanyD(dispatch, companyId, dateStart) {
	var dateEnd = parseInt(dateStart) + 86400000;
	LoopbackHttp.getFilterOrders(companyId, dateStart, dateEnd)
		.then(orders => {
			dispatch({ type: types.ORDERS_COMPANY_FETCHED, orders });
		})
		.catch(() => {
			dispatch({ type: types.ORDERS_COMPANY_FETCH_FAILED });
		});
}

export function getFilterOrdersForCompany(companyId, dateStart) {
	return (dispatch) => getFilterOrdersForCompanyD(dispatch, companyId, dateStart);
}


export function getTodayOrders(companyId) {
  return (dispatch) => getOrdersForDateImpl(dispatch, companyId, new Date());
}

export function getOrdersForDate(companyId, date) {
  return (dispatch) => getOrdersForDateImpl(dispatch, companyId, date);
}

export function getAllOrdersForCompany(companyId) {
  return (dispatch) => getAllOrdersForCompanyImpl(dispatch, companyId, new Date());
}


// WEBPACK FOOTER //
// ./src/actions/onDemandActions.js